export const taskTypes = [
  {label: "Recurso", value: "RESOURCE", color: "gold"},
  {label: "Actividad", value: "ACTIVITY",  color: "cyan"}
];